// extracted by mini-css-extract-plugin
export default {"container":"OrbSetupModule_container__uECWK","header":"OrbSetupModule_header__26vdZ","body":"OrbSetupModule_body__8-Vzp","inputAndLabel":"OrbSetupModule_inputAndLabel__KmvuH"};